import { render } from "./BrandLogo.vue?vue&type=template&id=00ec5e76&scoped=true"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"

import "./BrandLogo.vue?vue&type=style&index=0&id=00ec5e76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ec5e76"]])

export default __exports__